// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".spinoffs-modal .spinoffs-modal__list{display:grid;gap:1rem;grid-template-columns:1fr}.spinoffs-modal .spinoffs-modal__error{margin-top:64px}.spinoffs-modal .spinoffs-modal__preview .loading-container{height:300px;background-color:#24282f;color:#fff}.spinoffs-modal .spinoffs-modal__preview canvas{height:100%;width:100%}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
